import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { RankingJobConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { CvJobsService } from './api/cvJobs.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class RankingJobApiModule {
    public static forRoot(configurationFactory: () => RankingJobConfiguration): ModuleWithProviders<RankingJobApiModule> {
        return {
            ngModule: RankingJobApiModule,
            providers: [ { provide: RankingJobConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: RankingJobApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('RankingJobApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
